import store from '../../store/index'
import { find } from 'lodash'

export const findMember = (id) => {
    return find(store.state.company.members, { id: parseInt(id) })
}

export const findSource = (id) => {
    return find(store.state.sources.all, { id: parseInt(id) })
}

export const findLossReason = (id) => {
    return find(store.state.lossReasons.all, { id: parseInt(id) })
}

export const findAccessWay = (id) => {
    return find(store.state.accessWays.all, { id: parseInt(id) })
}

export const findSegment = (id) => {
    return find(store.state.segments.all, { id: parseInt(id) })
}

export const findCategory = (id) => {
    return find(store.state.productCategories.all, { id: parseInt(id) })
}

export const findProduct = (id) => {
    return find(store.state.products.all, { id: parseInt(id) })
}

export const findSupplier = (id) => {
    return find(store.state.suppliers.all, { id: parseInt(id) })
}

export const findCurrency = (id) => {
    return find(store.state.company.currencies, { id: parseInt(id) })
}

export const findPipeline = (id) => {
    return find(store.state.pipelines.all, { id: parseInt(id) })
}

export const findPipelineByStepId = (id) => {
    return find(store.state.pipelines.all, { steps: [{ id: parseInt(id) }] })
}

export const findPipelineStepById = (id) => {
    const pipeline = find(store.state.pipelines.all, { steps: [{ id: parseInt(id) }] })
    return find(pipeline.steps, { id: parseInt(id) })
}



// WEBPACK FOOTER //
// ./src/utils/helpers/find-store.js